import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const DosisSection = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), { defaultMatches: true });

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Tu marca en pantalla
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          La Dosis Positiva: Bienestar Diario
        </Box>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 640, mx: 'auto' }}>
          El espacio donde Lácteos Barinas será patrocinante del bloque de bienestar. Transmisión en vivo los jueves a las 2:00 PM por TNO Network.
        </Typography>
      </Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              borderRadius: isSm ? 4 : 0,
              boxShadow: 3,
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube.com/embed/K6NfYmbfGhk"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="La Dosis Positiva | Anuncia con nosotros"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box maxWidth={400} margin="0 auto" position="relative">
            <Box
              component="img"
              src="https://files.tnonetwork.com/shows/cover/ladosispositiva.png"
              alt="La Dosis Positiva"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                opacity: 0.5,
              }}
            />
            <Box
              component="img"
              src="https://files.tnonetwork.com/shows/logo/ladosispositiva.png"
              alt="Logo La Dosis Positiva"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '50%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Box mt={3} textAlign="center">
            <Box
              component="img"
              src="/images/yanirabocarandacandid.jpeg"
              alt="Yanira Bocaranda - La Dosis Positiva"
              sx={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: 2,
              }}
            />
            <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 1 }}>
              Yanira Bocaranda
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ancla de La Dosis Positiva
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DosisSection;
